<template>
  <div>
    <v-layout justify-center mt-3 wrap>

        <v-flex  xs2 mx-3 v-if="activeaccounts">
        <v-card min-width="120px" hover color="light-green" height="80px" class="rounded-card" @click="navigateServiceAccounts()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Active Accounts</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{activeaccounts.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="pendingapplications">
        <v-card min-width="120px" hover color="blue" height="80px" class="rounded-card" @click="navigateApplications()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">New Applications</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{pendingapplications.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs2 mx-3 v-if="changerequest">
        <v-card min-width="120px" hover color="orange" height="80px" class="rounded-card" @click="navigateServiceAccounts()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Change Requests</h3>
              </v-flex>
              <v-flex xs12>
                <h2 class="font-weight-bold">{{changerequest.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs2 mx-3 v-if="customerrequest">
        <v-card min-width="120px" hover color="purple" height="80px" class="rounded-card" @click="navigateServiceAccounts()">
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Customer Requests</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{customerrequest.count}}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
    <v-layout mt-2 justify-center align-center wrap>
        <v-flex v-if="packagedata.length>0" xs8 sm3 md3>
      <doughnutchart
      v-if="loaded"
      :chartdata="ispPackagesChartData"
      :options="ispPackagesChartOptions">
      </doughnutchart>
      
      </v-flex>
      <v-flex xs12 sm9 v-if="networks.length>0">
        <v-card flat>
          <!-- <v-toolbar flat color="primary" class="white--text">
            <h3 class="title white--text">Network Numbers:</h3>
          </v-toolbar> -->
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="networks"
            :rows-per-page-items="[5]"
            >
            <template v-slot:items="props">
           <td
          v-if="props.item.networkStatus==='Live'"
          class="text-xs-center"
        >
          <v-chip small class="white--text caption my-2" color="light-green">Live</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus==='In Progress'"
          class="text-xs-center"
        >
          <v-chip small class="white--text caption my-2" color="blue">In Progress</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus==='Planned'"
          class="text-xs-center"
        >
          <v-chip small class="white--text my-2" color="orange">Planned</v-chip>
        </td>
        <td
          v-if="props.item.networkStatus===null"
          class="text-xs-center"
        ></td>
          <td class="text-xs-center">{{props.item.backhaulType}}</td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.passed}}</td>
          <td class="text-xs-center">{{props.item.connected}}</td>
          <td class="text-xs-center">{{props.item.serviceAccounts}}</td>
          <td class="text-xs-center" v-if="props.item.serviceAccounts>0&&props.item.connected>0">{{Math.round((props.item.serviceAccounts/props.item.connected)*10000)/100}}%</td>
          <td class="text-xs-center" v-else>0%</td>
        </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

     <!-- <v-flex xs12 sm12 md12 v-if="networkdata.length>0">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex> -->
      <v-flex mt-5 xs3 v-if="packagedata.length===0&&networkdata.length===0&&networks.length === 0">
        <v-card>
        <v-card-text text-xs-center>
          <v-layout justiify-center >
            <v-flex xs12 text-xs-center>
            <span text-xs-center class="grey--text">No Data available</span>

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      </v-flex>
       <v-flex xs12 sm12 md12 v-if="networkdata.length>6">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs12 sm6 md6 v-else-if="networkdata.length>3">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs12 sm4 md4 v-else-if="networkdata.length>0">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
    </v-layout>
    <!-- <v-layout justify-center> -->
       <!-- <v-flex xs12 sm12 md12 v-if="networkdata.length>6">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs12 sm6 md6 v-else-if="networkdata.length>3">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex>
      <v-flex xs12 sm4 md4 v-else-if="networkdata.length>0">
          <barchart
          v-if="loaded"
      :chartdata="stackedData"
      :options="stackedDataOptions">
      </barchart>
      </v-flex> -->
    <!-- </v-layout> -->
    
  </div>
</template>
<script>
import BarChart from './BarChart.vue';
import PieChart from './PieChart.vue';
import LineChart from './LineChart.vue';
import DoughnutChart from './DoughnutChart.vue';

export default {
components: { 
  barchart: BarChart,
  piechart: PieChart,
  linechart: LineChart,
  doughnutchart: DoughnutChart
  },
  props: ["activeaccounts", "changerequest", "customerrequest", "networkdata", "networks", "networkspeeds", "packagedata", "pendingapplications"],
  data(){
      return {
          loaded: false,
          ispPackagesChartData: {},
          ispPackagesChartOptions: {},
          networkChartData: {},
          networkChartOptions: {},
          stackedData: {},
          stackedDataOptions: {},
          headers: [
            {
          text: "Status",
          align: "center",
          value: "networkStatus"
        },
        {
          text: "Backhaul Type",
          align: "center",
          value: "backhaulType"
        },
            {
          text: "Network",
          align: "center",
          value: "name"
        },
        {
          text: "Units Passed",
          align: "center",
          value: "passed"
        },
        {
          text: "Units Connected",
          align: "center",
          value: "connected"
        },
        {
          text: "My Live Accounts",
          align: "center",
          value: "serviceAccounts"
        },
        {
          text: "Presence Percentage",
          align: "center",
          sortable: false
        }
          ]
      }
  },
  created(){
        this.loaded = false

  },
  async mounted(){
      this.loadCharts()
  },
  methods: {
    navigateServiceAccounts(){
        this.$router.push({ path: "/ispServiceAccounts"})
    },
    navigateApplications(){
        this.$router.push({ path: "/ispApplications"})
    },
      async loadCharts(){
        //   Packages Chart
      let colors = this.getRandomColors(this.packagedata.length)
      this.ispPackagesChartData = {
        labels: this.packagedata.map(x=>x.speedProfile.downloadMbps+'Mbps'),
        datasets: [
        {
            label: 'Speed',
            data: this.packagedata.map(x=>x.count),
            backgroundColor: this.packagedata.map(x => this.pSBC(0.35, x.colour)),
            borderColor: this.packagedata.map(x => x.colour),
            borderWidth: 1
        }]},
        this.ispPackagesChartOptions={
        title: {
            display: true,
            text: 'Packages Sold by Speed'
        },
        tooltip: {
            enabled: true
        }
    }

    // Network Chart
    let networkColors = this.getRandomColors(this.networkdata.length)
    this.networkChartData = {
        labels: this.networkdata.map(x=>x.locationNetwork.name),
        datasets: [
        {
            label: 'Sold',
            data: this.networkdata.map(x=>x.count),
            backgroundColor: networkColors.background,
            borderColor: networkColors.border,
            borderWidth: 1
        }]},
        this.networkChartOptions={
        title: {
            display: true,
            text: 'Packages Sold by Network'
        },
        tooltip: {
            enabled: true
        }
    }

    await this.networkspeeds.map(z=>{
          let index = this.networkspeeds.indexOf(z)
           z.backgroundColor = this.pSBC(0.35, z.colour);
           z.borderColor = z.colour;
        })

     this.stackedData = {
        labels: this.networkdata.map(x=>x.locationNetwork.name),
        datasets: this.networkspeeds
        },
      this.stackedDataOptions= {
      responsive: true, 
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          stacked: true,
          categoryPercentage: 0.8,
          barPercentage: 1
        }],
        yAxes: [{
          stacked: true
        }]
      }}
      this.loaded= true

      },
    getRandomColors(number) {
  var letters = '0123456789ABCDEF';
  var color = '#';
  let array = {background: [], border: []}
  for (let x=0; x<number; x++){
      for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  array.border.push(color)
  array.background.push(this.pSBC(0.35, color))
  color = '#'
  }
  return array;
},
pSBC(p,c0,c1,l){
    let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
    if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
    if(!this.pSBCr)this.pSBCr=(d)=>{
        let n=d.length,x={};
        if(n>9){
            [r,g,b,a]=d=d.split(","),n=d.length;
            if(n<3||n>4)return null;
            x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
        }else{
            if(n==8||n==6||n<4)return null;
            if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
            d=i(d.slice(1),16);
            if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
            else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
        }return x};
    h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
    if(!f||!t)return null;
    if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
    else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
    a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
    if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
    else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
}
  }
};
</script>